import { useState } from 'react';
import type { MimeType } from '@repo/shared';
import { useMutation } from '@tanstack/react-query';

import { AXIOS_INSTANCE } from '@/api/instance';
import { useAuth } from '@/providers/auth-provider';

export interface UseFileDownloadProps {
  mutationKey: string;
  path: string;
}
export const useFileDownload = ({
  mutationKey,
  path,
}: UseFileDownloadProps) => {
  const { user } = useAuth();
  const [data, setData] = useState<{
    fileName: string;
    contentType: MimeType;
    url: string;
    blob: Blob;
    text: string;
  } | null>(null);

  const { mutateAsync: downloadFile, ...props } = useMutation({
    mutationKey: ['download', mutationKey],
    mutationFn: async () => {
      const response = await AXIOS_INSTANCE.get(path, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      });

      const fileName =
        response.headers['content-disposition'].split('filename=')[1];
      const contentType = response.headers['content-type'].split(';')[0];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const blob = response.data as Blob;
      const text = await blob.text();
      setData({ fileName, contentType, url, blob, text });
      return { fileName, contentType, url, blob, text };
    },
  });

  return { downloadFile, ...props, data };
};
